import { ReferralRequest } from "@/types";

import { axios } from "../axios.instance";

export type ApproveReferralRequest = {
  referralRequestId: ReferralRequest["id"];
};

export type ApproveReferralResponse = null;

export const approveReferral = async (params: ApproveReferralRequest): Promise<ApproveReferralResponse> => {
  const { data } = await axios.post(`/referral-requests/my/${params.referralRequestId}/approve`);

  return data;
};
